// src/api/modules/DisposalApi.js
import Methods from "../methods";
import {formatDate} from "../../util/date-util";

const searchDisposals = (context, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `api/disposals/search/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const getDisposalById = (context, id) => {
  const url = `api/disposals/${id}`;
  return Methods.doGet(context, url);
};

const getDisposalDetail = (context, payload) => {
  const {id, filters, page, size, sortBy = "createdOn", direction = "desc"} = payload;

  const url = `api/disposals/${id}/detail/search?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const changeStatusDisposal = (context, idDisposal, request) => {
  const url = `api/disposals/${idDisposal}/status`;
  return Methods.doPut(context, url, request, null);
};

const exportDisposalsExcel = (context, filters) => {
  const url = `api/disposals/export-excel`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_solicitudes_baja_${newDate}.xlsx`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const exportDisposalsPdf = (context, filters) => {
  const url = `api/disposals/export-pdf`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_solicitudes_baja_${newDate}.pdf`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const prepareExportDisposalOrderPdf = (context, disposalId) => {
  const url = `api/disposals/${disposalId}/export-order/prepare`;
  return Methods.doPost(context, url, {}, null);
};

const exportDisposalOrderPdf = (context, disposalId) => {
  const url = `api/disposals/${disposalId}/export-order`;
  const newDate = formatDate(new Date());
  const fileName = `Orden_solicitud_baja_${disposalId}_${newDate}.pdf`;

  return Methods.doPostDonwload(context, url, {}, fileName, null);
};

export default {
  searchDisposals,
  getDisposalById,
  getDisposalDetail,
  changeStatusDisposal,
  exportDisposalsExcel,
  exportDisposalsPdf,
  prepareExportDisposalOrderPdf,
  exportDisposalOrderPdf
};



// WEBPACK FOOTER //
// ./src/api/modules/DisposalApi.js